
<div class="modal-header">
    <h3>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
             class="bi bi-check-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path
                    d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
        </svg>
        Оплата підтверджена.
    </h3>

</div>
<p class="">Дякуємо за оплату!</p>

<div class="mt-3 d-flex flex-column">
    <button class="btn btn-block btn-primary " (click)="goTo(returnUrl)">Перейти до вибору тесту</button>
    <button class="btn btn-block btn-link text-secondary" (click)="goTo('/')">Повернутись на головну</button>
</div>


<!--<div class="modal-header">-->
<!--    <h5 class="modal-title">Оплата підтверджена</h5>-->
<!--    <button-->
<!--            type="button"-->
<!--            class="close"-->
<!--            (click)="onClose()"-->
<!--    >-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg"-->
<!--             viewBox="0 0 16 16">-->
<!--            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>-->
<!--        </svg>-->
<!--    </button>-->
<!--</div>-->
<!--<div class="modal-body pb-5" >-->
<!--    <p>Дякуємо за оплату!</p>-->
<!--    <button class="btn btn-primary" (click)="goTo(returnUrl)">Перейти до вибору тесту</button>-->
<!--    <button class="btn btn-secondary" (click)="goTo('/')">Повернутись на головну</button>-->
<!--</div>-->
